export default "__VITE_ASSET__DN5dvyhh__"